import { ColDef } from "ag-grid-community";
import {
  idColumn,
  actionColumn,
  statusColumn,
} from "../../../../../utils/commonColumns";
import { generateColumn, renderNA } from "../../../../../utils/commonFunctions";
export const nameColumn: ColDef = {
  field: "title",
  headerName: "Name",
  cellRenderer: (props: any) => {
    return renderNA(props.data.title);
  },
};
export const designationColumn: ColDef = {
  field: "subtitle",
  headerName: "Designation",
  cellRenderer: (props: any) => {
    return renderNA(props.data.subtitle);
  },
};

const columnDefs: ColDef[] = [
  idColumn,
  nameColumn,
  designationColumn,
  generateColumn("Description"),
  statusColumn,
  actionColumn,
];
export default columnDefs;
